import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  GetBusinessActivitiesResponse,
  GetBusinessActivitiesRequest,
  GetBusinessActivityRequestsResponse,
  GetBusinessActivityRequestsRequest,
  GetBusinessActivityRequestDetails,
  GetBusinessActivityRequestDetailsResponse,
} from "./types";
import { baseQueryCreator } from "redux/baseQuery";
import env from "env";
import dayjs from "dayjs";

const { businessActivityService } = env.api.baseUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: businessActivityService,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const businessActivityApi = createApi({
  reducerPath: "businessActivityApi",
  baseQuery: baseQueryCreator(baseQuery),
  refetchOnMountOrArgChange: true,
  tagTypes: ["BusinessActivity"],
  endpoints: (builder) => ({
    getBusinessActivities: builder.query<
      GetBusinessActivitiesResponse,
      GetBusinessActivitiesRequest
    >({
      query: (params) => {
        return {
          url: `/trackings/batches`,
          method: "GET",
          params: {
            ...params,
            fromDateTime: params.fromDateTime
              ? dayjs(params.fromDateTime).format("YYYY-MM-DDTHH:mm:ssZ")
              : undefined,
            toDateTime: params.toDateTime
              ? dayjs(params.toDateTime)
                  .endOf("day")
                  .format("YYYY-MM-DDTHH:mm:ssZ")
              : undefined,
          },
        };
      },
    }),
    getBusinessActivityRequests: builder.query<
      GetBusinessActivityRequestsResponse,
      GetBusinessActivityRequestsRequest
    >({
      query: (params) => {
        return {
          url: `/trackings/requests`,
          method: "GET",
          params: {
            ...params,
            fromDateTime: params.fromDateTime
              ? dayjs(params.fromDateTime).format("YYYY-MM-DDTHH:mm:ssZ")
              : undefined,
            toDateTime: params.toDateTime
              ? dayjs(params.toDateTime).format("YYYY-MM-DDTHH:mm:ssZ")
              : undefined,
          },
        };
      },
    }),
    getBusinessActivityRequestDetails: builder.query<
      GetBusinessActivityRequestDetailsResponse,
      GetBusinessActivityRequestDetails
    >({
      query: (params) => {
        return {
          url: `/trackings/requests/${params.requestId}`,
          method: "GET",
          params: {
            ...params,
            pageSize: params.pageSize,
            pageNumber: params.pageNumber,
            fromDateTime: params.fromDateTime
              ? dayjs(params.fromDateTime).format("YYYY-MM-DDTHH:mm:ssZ")
              : undefined,
            toDateTime: params.toDateTime
              ? dayjs(params.toDateTime).format("YYYY-MM-DDTHH:mm:ssZ")
              : undefined,
          },
        };
      },
    }),
  }),
});

export const {
  useGetBusinessActivitiesQuery,
  useGetBusinessActivityRequestsQuery,
  useGetBusinessActivityRequestDetailsQuery,
} = businessActivityApi;
export const { useQueryState: useGetWalletByOrgIdQueryState } =
  businessActivityApi.endpoints.getBusinessActivities;
